import { render } from "./PdfParseQueueList.vue?vue&type=template&id=2cdb5655&scoped=true"
import script from "./PdfParseQueueList.vue?vue&type=script&lang=js"
export * from "./PdfParseQueueList.vue?vue&type=script&lang=js"

import "./PdfParseQueueList.vue?vue&type=style&index=0&id=2cdb5655&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdb5655"]])

export default __exports__